export default "__VITE_ASSET__8902ea02__"